import { forwardRef } from 'react';
import Fuse from 'fuse.js';
import { SoftphoneTypes } from '@frontend/api-softphone';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, styles, Text } from '@frontend/design-system';
import { UserWithPresence, isUserWithPresence } from '../../providers/softphone-users-provider';
import { highlightMatches } from './autocomplete-utils';

type Props = {
  device: SoftphoneTypes.User | UserWithPresence;
  matches?: readonly Fuse.FuseResultMatch[] | undefined;
  onClick: () => void;
  trackingId?: string;
  active?: boolean;
};

export const AutocompleteDevice = forwardRef<HTMLLIElement, Props>(({ device, onClick, matches, active }, ref) => {
  const hasPresence = isUserWithPresence(device);
  const status = hasPresence ? device.status : 'unknown';

  return (
    <li
      ref={ref}
      data-trackingid='softphone-dial-extensions'
      className={`device status-${status}`}
      key={device.id}
      css={{
        background: active ? theme.colors.neutral70 : 'transparent',
      }}
    >
      <PopoverMenuItem
        css={{
          background: 'transparent',
        }}
        className='list-item'
        onClick={onClick}
        active={active}
      >
        <Text color='white' css={styles.multilineTruncate(2)}>
          <span className={`device-status status-${status}`} />
          {matches === undefined
            ? device.name
            : highlightMatches(device.name, (matches?.[0]?.indices ?? []) as [number, number][])}
        </Text>
      </PopoverMenuItem>
    </li>
  );
});

AutocompleteDevice.displayName = 'AutocompleteDevice';
